import React from 'react';
export function ContentSection() {
  return <section className="w-full bg-sand-100 py-16 md:py-24 px-6" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-46">
          <div data-id="element-47">
            <h3 className="font-serif text-2xl md:text-4xl mb-7 leading-tight uppercase tracking-wide font-[900] text-[#D4956B]" data-id="element-48">
              Ebook principal: Florecer
            </h3>

            <ul className="space-y-3 text-charcoal-500 font-light mb-8" data-id="element-49">
              {[{
              title: 'Capítulo 1',
              subtitle: 'Primeros meses de embarazo',
              desc: 'Empezá esta etapa con más tranquilidad y sin miedo'
            }, {
              title: 'Capítulo 2',
              subtitle: 'Nacimiento y parto',
              desc: 'Prepararte para el parto con seguridad y claridad'
            }, {
              title: 'Capítulo 3',
              subtitle: 'Posparto y cuidados en casa',
              desc: 'Cómo cuidar a tu bebé desde el primer día sin sentirte perdida'
            }, {
              title: 'Capítulo 4',
              subtitle: 'Posparto: más consejos',
              desc: 'Todo lo que necesitás para el día a día, explicado simple'
            }, {
              title: 'Capítulo 5',
              subtitle: 'Situaciones comunes del bebé',
              desc: 'Reconocer señales importantes sin entrar en pánico'
            }, {
              title: 'Capítulo 6',
              subtitle: 'Vos como mamá',
              desc: 'Sentirte segura, confiar en vos y vivir esta etapa con más calma'
            }].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-50">
                  <span className="text-sage-500 mt-1 text-xs" data-id="element-51">●</span>
                  <div data-id="element-52">
                    <span className="text-sm font-medium text-charcoal-600" data-id="element-53">
                      {item.title}
                    </span>
                    <p className="text-sm text-charcoal-600 font-medium leading-snug" data-id="element-54">
                      {item.subtitle}
                    </p>
                    <p className="text-xs text-charcoal-400 leading-snug" data-id="element-55">
                      {item.desc}
                    </p>
                  </div>
                </li>)}
            </ul>

            <p className="font-serif italic text-xl text-warm-500" data-id="element-56">
              Todo explicado de forma clara y aplicable
            </p>
          </div>

          <a href="https://checkout.aulamater.online/cart/44073141076067:1" className="block overflow-hidden transition-opacity duration-500 hover:opacity-90" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/4jaygYJCiPBM8mEdpwBLeg/e56f482371d632342056a0c28e799912.jpg" alt="Maternidad real" className="w-full h-[500px] object-cover" data-id="element-58" />
          </a>
        </div>
      </div>
    </section>;
}